import { Link } from "react-router-dom";
import { categorieMegaMenuItems } from "../../data/mainMenuData";
import {
  isActiveParent,
  isActiveLink,
  isActiveParentChaild,
} from "../../utils/linkActiveChecker";
import { useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import {DateObject} from "react-multi-date-picker";
import getTripTitle from "@/utils/getTripTitle.js";

const CategoriesMegaMenu = ({ setIsActiveParent }) => {
  const { pathname } = useLocation();
  const [activeNestedMenu, setActiveNestedMenu] = useState(0);
  const [featuredTrip, setFeaturedTrip] = useState(null);

  const itemList = [
    "Hotel"
  ];

  useEffect(() => {
    fetch("https://api.tripsi.pl/api/trips/best")
      .then((response) => response.json())
      .then((data) => {
        const trip = Array.isArray(data) && data.length > 0
            ? data[Math.floor(Math.random() * data.length)]
            : null;
        setFeaturedTrip(trip);
      });
  }, []);



  useEffect(() => {
    categorieMegaMenuItems.map((megaMenu) => {
      megaMenu?.menuCol?.map((megaCol) => {
        megaCol?.menuItems?.map((item) => {
          item?.menuList?.map((list) => {
            if (list.routePath?.split("/")[1] == pathname.split("/")[1]) {
              setIsActiveParent(true);
              setActiveNestedMenu(megaMenu.id - 1);
            }
          });
        });
      });
    });
  }, []);

  function getRoutePath(list) {
    const routePath = list.routePath.replace("uniqueDestinations=false", "uniqueDestinations=true");
    if(list.name === "Last minute") {
        return routePath + '&dateFrom=' + new DateObject().format('YYYY-MM-DD') + '&dateTo=' + new DateObject().add(14, 'days').format('YYYY-MM-DD')
    }
    return routePath;
  }

  const inspirationDetails = {
    "Romantyczny weekend": ["💙", "Krótki wyjazd we dwoje"],
    "Tydzień zwiedzania": ["🧭", "Miasta, kultura i lokalne odkrycia"],
    "Tydzień wypoczynku": ["☀️", "Spokojny reset w cieple"],
    "Weekendowy city break": ["🏙️", "Dużo wrażeń w 3–5 dni"],
    "Najtaniej": ["💸", "Najlepsze ceny za dzień"],
    "Last minute": ["⚡", "Wyjazdy w ciągu 14 dni"],
  };

  return (
    <div className="tabs -underline-2 js-tabs">
      {/*<div className="tabs__controls row x-gap-40 y-gap-10 lg:x-gap-20 pb-30 js-tabs-controls">*/}
      {/*  {itemList.map((item, i) => (*/}
      {/*    <div*/}
      {/*      className="col-auto"*/}
      {/*      key={i}*/}
      {/*      onClick={() => setActiveNestedMenu(i)}*/}
      {/*    >*/}
      {/*      <button*/}
      {/*        className={`tabs__button text-light-1 fw-500 js-tabs-button ${*/}
      {/*          activeNestedMenu == i*/}
      {/*            ? "nested-menu-active"*/}
      {/*            : "nested-menu-inactive"*/}
      {/*        } `}*/}
      {/*      >*/}
      {/*        {item}*/}
      {/*      </button>*/}
      {/*    </div>*/}
      {/*  ))}*/}
      {/*</div>*/}
      {/* End tab-controls */}

      <div className="tabs__content js-tabs-content">
        <div className={"react-tabs__tab-panel--selected"}>
          {categorieMegaMenuItems[activeNestedMenu]?.menuCol?.map(
            (megaCol, i) => (
              <ul className="mega__content" key={i}>
                <li className="mega__grid">
                  <div className="mega__item inspirationCreatorLink">
                    <Link to="/kreator-podrozy" className="inspirationChoice">
                      <span className="inspirationChoice__icon" aria-hidden="true">✦</span>
                      <span>Kreator podróży <small>NOWE</small></span>
                    </Link>
                  </div>
                  {megaCol?.menuItems?.map((item) => (
                    <div className="mega__item" key={item.id}>
                      <div className="text-15 fw-500">{item.title}</div>
                      <div className="y-gap-5 text-15 pt-5">
                        {item?.menuList?.map((list, i) => (
                          <div
                            key={i}
                            className={
                              isActiveLink(list.routePath, pathname)
                                ? "current"
                                : ""
                            }
                          >
                            <Link className="inspirationChoice" to={getRoutePath(list)}>
                              <span className="inspirationChoice__icon" aria-hidden="true">{inspirationDetails[list.name]?.[0] || "✈️"}</span>
                              <span>{list.name}</span>
                            </Link>
                          </div>
                        ))}
                      </div>
                    </div>
                  ))}
                </li>
                {/* End mega menu list left */}

                <li className="mega__image d-flex relative">
                  {/* destinationData.photoUrl is "" (not undefined/null) for destinations outside
                      the curated CMS list, common for flight-only results - see
                      TourProperties.jsx's getImageWrapper() for the same fallback. Without this,
                      an empty src renders a broken-image icon behind the overlaid title. */}
                  {featuredTrip?.destinationData?.photoUrl ? (
                    <img
                      src={featuredTrip.destinationData.photoUrl}
                      alt={`Inspiracja podróżnicza: ${featuredTrip?.destinationData?.name || "aktualna oferta"}`}
                      className="rounded-4 js-lazy"
                    />
                  ) : (
                    // .mega__image (the <li>) has no height of its own - it's sized by the <img>'s
                    // width:100%/min-height:300px (see header.scss) - so the placeholder needs the
                    // same width/min-height explicitly, w-full/h-full alone would collapse to 0.
                    <div
                      className="rounded-4 w-full d-flex items-center justify-center"
                      style={{
                        minHeight: "300px",
                        background: "linear-gradient(135deg, var(--color-dark-1), var(--color-blue-1))",
                      }}
                    >
                      <div className="icon-airplane text-40 text-white"></div>
                    </div>
                  )}

                  {/* Dark scrim behind the overlaid text: plain white text directly on a photo
                      reads fine over a dark patch of sky and unreadable over a bright building or
                      sky, depending entirely on which random trip/photo landed here - a gradient
                      floor under the text (plus a text-shadow as a second line of defense) keeps
                      it legible regardless of the underlying image. */}
                  <div
                    className="absolute w-full h-full rounded-4"
                    style={{
                      background: "linear-gradient(180deg, rgba(0,0,0,0) 40%, rgba(0,0,0,0.75) 100%)",
                      pointerEvents: "none",
                    }}
                  />

                  <div className="absolute w-full h-full px-30 py-24">
                    <div
                      className="text-22 fw-500 lh-15 text-white"
                      style={{ textShadow: "0 1px 4px rgba(0,0,0,0.65)" }}
                    >
                      {featuredTrip ? getTripTitle(featuredTrip) : "Najlepsze aktualne okazje"}
                    </div>
                    <Link
                      to={featuredTrip ? `/tour-single/${featuredTrip.id}` : "/best-offers"}
                      className="button text-uppercase h-50 px-30 -blue-1 text-dark-1 bg-white mt-20 d-inline-flex"
                    >
                      {featuredTrip ? megaCol?.btnText : "Zobacz najlepsze oferty"}
                    </Link>
                  </div>
                </li>
                {/* End mega menu right images */}
              </ul>
            ),
          )}
        </div>
      </div>
      {/* End tab_content */}
    </div>
  );
};

export default CategoriesMegaMenu;
